import React, { useState, FunctionComponent, useEffect } from 'react';
import { withStyles, Theme, createStyles, MuiThemeProvider, createTheme } from '@material-ui/core/styles';
import Switch, { SwitchClassKey, SwitchProps } from '@material-ui/core/Switch';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

const theme = createTheme({
  palette: {
    primary: {
      main: '#304ffe',
    },
    secondary: {
      main: '#B0B0B0',
    },
  },
  typography: {
    fontSize: 12,
    fontFamily: 'Source Sans Pro, sans-serif',
  },
});

interface Styles extends Partial<Record<SwitchClassKey, string>> {
  focusVisible?: string;
}

interface Props extends SwitchProps {
  classes: Styles;
}

const AntSwitch = withStyles((theme: Theme) =>
  createStyles({
    root: {
      width: 20,
      height: 11,
      padding: 0,
      display: 'flex',
    },
    switchBase: {
      padding: 0,
      color: theme.palette.secondary.main,
      top: '1px',
      left: '1px',
      '&$checked': {
        transform: 'translate(10px, 1px)',
        top: 0,
        left: 'auto',
        color: theme.palette.common.white,
        '& + $track': {
          opacity: 1,
          backgroundColor: theme.palette.primary.main,
          borderColor: theme.palette.primary.main,
        },
      },
    },
    thumb: {
      width: 9,
      height: 9,
      boxShadow: 'none',
      background: theme.palette.common.white,
    },
    track: {
      border: `1px solid ${theme.palette.secondary.main}`,
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor: theme.palette.secondary.main,
    },
    checked: {},
  }),
)(Switch);

const CustomizedSwitch: FunctionComponent<{
  isChecked: boolean;
  handleEvChange?: Function;
  onText?: string;
  offText?: string;
}> = ({ isChecked = false, handleEvChange, onText = 'ON', offText = 'OFF' }) => {
  const [checked, setChecked] = useState(isChecked);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = event.target;
    setChecked(checked);
    if (handleEvChange) {
      handleEvChange(checked);
    }
  };

  useEffect(() => {
    setChecked(isChecked);
  }, [isChecked]);

  return (
    <MuiThemeProvider theme={theme}>
      <Typography component="div">
        <Grid component="label" container alignItems="center" spacing={1} style={{ width: 'auto' }}>
          <Grid item>
            <AntSwitch checked={checked} onChange={handleChange} name="checked" />
          </Grid>
          <Grid item>{checked ? onText : offText}</Grid>
        </Grid>
      </Typography>
    </MuiThemeProvider>
  );
};

export default CustomizedSwitch;
